import classNames from "classnames/bind";
import styles from './PendingAccept.module.css';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    SearchBlack,
    SuccessIcon,
    ErrorIcon,
    CloseIcon,
    DeleteIcon
} from "../../../../components/Icons/Icons";
import { Alert, Loading, Switch, Table } from "../../../../components";
import { penddingAcceptCamServiceAPI } from "../../../../services/api/peddingAcceptCamServiceAPI";
import { getTimeFormArray } from "../../../../utils";

const cx = classNames.bind(styles);



function PendingAccept() {
    const [loading, setLoading] = useState(true)
    // const [isRefresh, setIsRefresh] = useState(false);
    // const [textSearch, setTextSearch] = useState();
    const [dataInput, setDataInput] = useState("");
    // const [code, setCode] = useState();
    const [isDelete, setIsDelete] = useState(false);
    const [isExtend, setIsExtend] = useState(false);
    const [data, setData] = useState([])
    // const ref = React.useRef(null);

    useEffect(() => {
        const demoLoading = setTimeout(() => {
            setLoading(false)
        }, 1000);
        return () => clearTimeout(demoLoading)
    }, [])
    const handleDelete = (code) => {
        setIsDelete(!isDelete)
    };

    const handleExtend = (code) => {
        setIsExtend(!isExtend)
    }
    const onChangeTextSearch = (e) => {
        setDataInput(e.target.value);
        // if (ref.current) {
        //     clearTimeout(ref.current);
        // }
        // ref.current = setTimeout(() => {
        //     const data = e.target.value;
        //     setTextSearch(data);
        //     setIsRefresh(!isRefresh)
        // }, 300);
    };
    const handleClose = () => {
        setIsExtend(false)
        setIsDelete(false)
    };
    const handleAdd = () => {
        setIsDelete(!isDelete)
    };

    const handleDeletService = () => {
        setIsDelete(!isDelete)
    }

    useEffect(() => {
        const getListReqPenddingAccept = async () => {
            try {
                const params = {
                    action: 0
                }
                const res = await penddingAcceptCamServiceAPI.get(params);
                const listReq = res?.data?.map((item, index) => {
                    return {
                        stt: index + 1,
                        namService: item?.serviceCode?.subjectName,
                        resolution: item?.quality?.quality,
                        timeSaveRecord: 14,
                        timeStart: getTimeFormArray(item?.timeStart),
                        autoReNew: item?.autoRenew === 1,
                        totalPrice: `${item?.price} VND`,
                        // 'cancel', 'reject', 'pending'
                        status: 'cancel'
                    }
                })
                setData(listReq);
            } catch (error) {
                
            }
        }
        getListReqPenddingAccept()
    }, [])

    const listStatus = [
        {
            code: 'pending',
            mesage: <span className={cx('tag')}>
                <SuccessIcon />
                <p className={cx('label', 'success')}>Chờ xác nhận</p>
            </span>
        },
        {
            code: 'reject',
            mesage: <span className={cx('tag')}>
                <ErrorIcon />
                <p className={cx('label', 'dismit')}>Từ chối</p>
            </span>
        },
        {
            code: 'cancel',
            mesage: <span className={cx('tag')}>
                <CloseIcon />
                <p className={cx('label', 'cancel')}>Đã huỷ</p>
            </span>
        },
    ]

    const dataSource = data.map((item, index) => {
        return {
            stt: item.stt,
            namService: item.namService,
            resolution: item.resolution,
            timeSaveRecord: item.timeSaveRecord,
            timeStart: item.timeStart,
            autoReNew: <div className={cx('auto_renew')}><Switch type="small" value={item.autoReNew} disable /></div>,
            totalPrice: item.totalPrice,
            status: listStatus.find(st => st.code === item.status).mesage,
            action: <div className={cx('auto_renew')}>
                {item.status === 'pending' && <button onClick={handleDeletService}><DeleteIcon /></button>}
            </div>
        }
    })

    const columns = [
        {
            label: <div className={cx('center')} style={{ width: '40%' }}>STT</div>,
            key: "stt",
        },
        {
            label: 'Tên dịch vụ',
            key: "namService",
        },
        {
            label: "Chất lượng hình ảnh",
            key: "resolution",
        },
        {
            label: 'Thời gian lưu trữ',
            key: "timeSaveRecord",
        },
        {
            label: 'Thời gian bắt đầu',
            key: "timeStart",
        },
        {
            label: 'Gia hạn/ tự động gia hạn',
            key: "autoReNew",
        },
        {
            label: 'Tổng tiền',
            key: "totalPrice",
        },
        {
            label: 'Trạng thái',
            key: "status",
        },
        {
            label: '',
            key: "action",
        },
    ];

    return (
        <>
            {isDelete && (
                <Alert
                    type="alert"
                    title="Bạn có muốn huỷ đăng ký dịch vụ này không"
                    onClose={handleClose}
                    onOk={handleAdd}
                />
            )}
            {isExtend && (
                <Alert
                    type="success"
                    title="Bạn có muốn gia hạn không"
                    onClose={handleClose}
                    onOk={handleAdd}
                />
            )}
            <div className={cx("content")}>
                <div className={cx("filter")}>
                    <div className={cx("search")}>
                        <input
                            className={cx("search-input")}
                            value={dataInput}
                            onChange={onChangeTextSearch}
                            placeholder="Tìm kiếm..."
                        />
                        <span className={cx("icon-search")}>
                            <SearchBlack />
                        </span>
                    </div>
                </div>
                {!loading ? (
                    <Table colum={columns} data={dataSource} />
                ) : (
                    <div className={cx("loading")}>
                        <Loading />
                    </div>
                )}

            </div>
        </>
    )
};

export default PendingAccept;